/**
* This file was automatically generated by @cosmwasm/ts-codegen@1.12.1.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { Uint128, InstantiateMsg, ExecuteMsg, ProposalStatus, Outcome, Proposal, Tally, QueryMsg, MarketStatus, ClaimResponse, MarketResponse, Uint256, PoolsResponse, OutcomeAccum, PositionResponse, MarketsResponse } from "./Madvotes.types";
import { MadvotesQueryClient } from "./Madvotes.client";
export interface MadvotesReactQuery<TResponse, TData = TResponse> {
  client: MadvotesQueryClient | undefined;
  options?: Omit<UseQueryOptions<TResponse, Error, TData>, "'queryKey' | 'queryFn' | 'initialData'"> & {
    initialData?: undefined;
  };
}
export interface MadvotesListMarketsQuery<TData> extends MadvotesReactQuery<MarketsResponse, TData> {
  args: {
    limit?: number;
    startAfter?: number;
    status?: MarketStatus;
  };
}
export function useMadvotesListMarketsQuery<TData = MarketsResponse>({
  client,
  args,
  options
}: MadvotesListMarketsQuery<TData>) {
  return useQuery<MarketsResponse, Error, TData>(["madvotesListMarkets", client?.contractAddress, JSON.stringify(args)], () => client ? client.listMarkets({
    limit: args.limit,
    startAfter: args.startAfter,
    status: args.status
  }) : Promise.reject(new Error("Invalid client")), {
    ...options,
    enabled: !!client && (options?.enabled != undefined ? options.enabled : true)
  });
}
export interface MadvotesGetClaimQuery<TData> extends MadvotesReactQuery<ClaimResponse, TData> {
  args: {
    depositor: string;
    proposalId: number;
  };
}
export function useMadvotesGetClaimQuery<TData = ClaimResponse>({
  client,
  args,
  options
}: MadvotesGetClaimQuery<TData>) {
  return useQuery<ClaimResponse, Error, TData>(["madvotesGetClaim", client?.contractAddress, JSON.stringify(args)], () => client ? client.getClaim({
    depositor: args.depositor,
    proposalId: args.proposalId
  }) : Promise.reject(new Error("Invalid client")), {
    ...options,
    enabled: !!client && (options?.enabled != undefined ? options.enabled : true)
  });
}
export interface MadvotesGetPoolsQuery<TData> extends MadvotesReactQuery<PoolsResponse, TData> {
  args: {
    proposalId: number;
  };
}
export function useMadvotesGetPoolsQuery<TData = PoolsResponse>({
  client,
  args,
  options
}: MadvotesGetPoolsQuery<TData>) {
  return useQuery<PoolsResponse, Error, TData>(["madvotesGetPools", client?.contractAddress, JSON.stringify(args)], () => client ? client.getPools({
    proposalId: args.proposalId
  }) : Promise.reject(new Error("Invalid client")), {
    ...options,
    enabled: !!client && (options?.enabled != undefined ? options.enabled : true)
  });
}
export interface MadvotesGetPositionQuery<TData> extends MadvotesReactQuery<PositionResponse, TData> {
  args: {
    depositor: string;
    proposalId: number;
  };
}
export function useMadvotesGetPositionQuery<TData = PositionResponse>({
  client,
  args,
  options
}: MadvotesGetPositionQuery<TData>) {
  return useQuery<PositionResponse, Error, TData>(["madvotesGetPosition", client?.contractAddress, JSON.stringify(args)], () => client ? client.getPosition({
    depositor: args.depositor,
    proposalId: args.proposalId
  }) : Promise.reject(new Error("Invalid client")), {
    ...options,
    enabled: !!client && (options?.enabled != undefined ? options.enabled : true)
  });
}
export interface MadvotesGetMarketQuery<TData> extends MadvotesReactQuery<MarketResponse, TData> {
  args: {
    proposalId: number;
  };
}
export function useMadvotesGetMarketQuery<TData = MarketResponse>({
  client,
  args,
  options
}: MadvotesGetMarketQuery<TData>) {
  return useQuery<MarketResponse, Error, TData>(["madvotesGetMarket", client?.contractAddress, JSON.stringify(args)], () => client ? client.getMarket({
    proposalId: args.proposalId
  }) : Promise.reject(new Error("Invalid client")), {
    ...options,
    enabled: !!client && (options?.enabled != undefined ? options.enabled : true)
  });
}
export interface MadvotesGetProposalQuery<TData> extends MadvotesReactQuery<Proposal, TData> {
  args: {
    proposalId: number;
  };
}
export function useMadvotesGetProposalQuery<TData = Proposal>({
  client,
  args,
  options
}: MadvotesGetProposalQuery<TData>) {
  return useQuery<Proposal, Error, TData>(["madvotesGetProposal", client?.contractAddress, JSON.stringify(args)], () => client ? client.getProposal({
    proposalId: args.proposalId
  }) : Promise.reject(new Error("Invalid client")), {
    ...options,
    enabled: !!client && (options?.enabled != undefined ? options.enabled : true)
  });
}